import React from 'react';
import PropTypes from 'prop-types';

import SidebarSearch from './sidebar_search';
import { Button } from 'react-bootstrap-5';

export default class FilterSelector extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    searchText: PropTypes.string,
    searchTextPlaceHolder: PropTypes.string,
    onCancelFilter: PropTypes.func,
    onSearchChange: PropTypes.func.isRequired,
    onSetDefaultFilters: PropTypes.func,
    onSetFilters: PropTypes.func,
  };

  static defaultProps = {
    searchTextPlaceHolder: 'Search fields...',
  };

  renderSearchBar() {
    const { searchText, searchTextPlaceHolder, onSearchChange } = this.props;

    return (
      <SidebarSearch
        additionalClasses="w-100"
        key="search-bar"
        placeholder={searchTextPlaceHolder}
        size="xs"
        value={searchText}
        onChange={onSearchChange}
      />
    );
  }

  renderDefaultButton() {
    const { onSetDefaultFilters } = this.props;

    if (onSetDefaultFilters == null) return;

    return (
      <Button
        className="flex-shrink-0"
        size="sm"
        variant="ghost"
        onClick={onSetDefaultFilters}
      >
        Restore Defaults
      </Button>
    );
  }

  render() {
    const { children, onCancelFilter, onSetFilters } = this.props;

    return (
      <div className="filter-selector-popover">
        <div className="d-flex flex-column gap-1 align-items-end">
          {this.renderSearchBar()}
          {this.renderDefaultButton()}
        </div>
        <div className="d-flex flex-column overflow-y-auto" style={{ maxHeight: '200px' }}>{children}</div>
        <div className="d-flex align-items-center justify-content-end gap-2 mt-3">
          {onCancelFilter && (
            <Button variant="ghost" onClick={onCancelFilter}>
              Cancel
            </Button>
          )}
          {onSetFilters && <Button onClick={onSetFilters}>Apply</Button>}
        </div>
      </div>
    );
  }
}
